import { createI18n } from 'vue-i18n'
import zhHans from './zh-Hans'
import zhHK from './zh-HK'
import en from './en'
// uni.getStorageSync('user_locale') ||
const i18n = createI18n({
    locale: 'zh-HK', // 默认语言
    fallbackLocale: 'en',
    legacy: false, // 使用 Composition API 模式
    globalInjection: true, // 全局注入 $t
    messages: {
        'zh-Hans': zhHans,
        'zh-HK': zhHK,
        en
    }
})

export default i18n
